import { withFocusRing } from "@components/Accessibility/FocusRing/FocusRing";
import FormCheckbox from "@components/Form/FormCheckbox";
import { styledWithInvalidProps } from "@components/Styled/StyledWithInvalidProps";
import React from "react";
import tw from "twin.macro";
import { type SizeType, withFilterSectionBox } from "./withFilterSectionBox";

const List = tw.ul`
  list-none flex flex-wrap py-maxi w-full
`;
const ListItem = tw.li`
  w-1/3 pr-pico
`;
const FilterButton = withFocusRing(
  styledWithInvalidProps("button")(({ active }) => [
    tw`relative flex items-center justify-center h-[56px] text-hint m-nano border focus:outline-none w-full`,
    active ? tw`text-white bg-primary` : tw`bg-transparent text-primary`,
  ]),
);
const ButtonLabel = tw.label`
  text-center pb-nano
`;
const ButtonSecondaryInfo = tw.p`
  text-caption
`;
const Checkbox = withFocusRing(tw(FormCheckbox)`
  absolute inset-0 w-full h-full appearance-none opacity-0 cursor-pointer focus-visible:opacity-100 
`);

const EmptyFilterLabel = tw.p`
  text-quaternary
`;

export const FilterSectionBox = withFilterSectionBox(
  ({
    className,
    convertedSizing,
    handleChange,
    handleClick,
    layout,
    options,
    value,
  }) => {
    return (
      <>
        <List>
          {!options.length ? (
            <EmptyFilterLabel>No products found</EmptyFilterLabel>
          ) : null}
          {options
            ?.sort((a, b) => parseInt(a.key) - parseInt(b.key))
            ?.map(({ key }) => (
              <ListItem key={key.toString()}>
                <FilterButton
                  aria-current={value[key] || value === key}
                  active={value[key] || value === key}
                  className={className}
                  title={key}
                  onClick={handleClick}
                >
                  <ButtonLabel>
                    <Checkbox
                      value={key}
                      checked={key}
                      handleChange={handleChange}
                      onChange={handleChange}
                      onKeyPress={handleChange}
                      internalState
                      tabIndex={-1}
                    />
                    <span>{key}</span>
                    {layout !== "heroBanner" && convertedSizing !== null
                      ? convertedSizing.map(
                          ({
                            bared,
                            us_au,
                          }: {
                            bared: SizeType["bared"];
                            us_au: SizeType["us_au"];
                          }) => {
                            if (bared === key)
                              return (
                                <ButtonSecondaryInfo>{`US ${us_au}`}</ButtonSecondaryInfo>
                              );
                          },
                        )
                      : null}
                  </ButtonLabel>
                </FilterButton>
              </ListItem>
            ))}
        </List>
      </>
    );
  },
);
